module.exports = __webpack_public_path__ + "static/media/29ADMSPC13.0f4f14e7.jpg";